import React from "react";

export const EmailMessaging = () => {
  return <div>EmailMessaging</div>;
};

export default EmailMessaging;
